import React from "react";

import { Link } from "gatsby";

import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { storageLocal as storage } from "../../../../utils/StorageHandler";
import useStore from "../../../pages/TechnicShop/store";
import { IconPredefined } from "../../icons/Icon";
import { PredefinedIconType } from "../../icons/Icon/Predefined";

const IconContainer = styled.div`
    position: relative;
    display: none;
    ${({ theme }) => theme.breakpoints.upTo.medium.css`
          margin-top: 0.25em;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        margin-left: 1em;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
          display: block;
    `}
`;

const CartQuantityIndicator = styled.span`
    position: absolute;
    bottom: 0.5em;
    left: 1em;
    display: inline-block;
    width: 1.25em;
    height: 1.25em;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1.25em;
    color: ${({ theme }) => theme.colors.white.toString()};
    text-align: center;
    background-color: ${({ theme }) => theme.colors.red.toString()};
    border-radius: 50%;
`;

const CartNav = styled.div`
    position: relative;
    margin-bottom: 8px;
`;

const TechnicList = () => {
    const { savedProducts } = useStore((state) => ({
        savedProducts: state.savedProducts,
    }));

    if (!storage.get("technic:saved-products")) {
        return null;
    }

    return (
        <>
            <IconContainer>
                <Icon quantity={savedProducts?.length ?? 0} />
            </IconContainer>
        </>
    );
};

interface iCartIconProps {
    quantity: number;
    linkToCart?: string;
}
export const Icon = ({
    quantity = 0,
    linkToCart = "/technik/list",
}: iCartIconProps) => {
    const theme = useTheme();
    return (
        <Link to={linkToCart}>
            <CartNav>
                <IconPredefined
                    type={PredefinedIconType.bookmark}
                    size="1em"
                    color={theme.colors.red.toString()}
                />
                {quantity > 0 && (
                    <CartQuantityIndicator>{quantity}</CartQuantityIndicator>
                )}
            </CartNav>
        </Link>
    );
};

export default TechnicList;
